{
  "kalla": "canboat 6.2.0 (@canboat/ts-pgns 1.11.18, canboat.json), Apache License 2.0",
  "tillverkare": [
    { "kod": 69, "namn": "ARKS Enterprises, Inc." },
    { "kod": 78, "namn": "FW Murphy/Enovation Controls" },
    { "kod": 80, "namn": "Twin Disc" },
    { "kod": 85, "namn": "Kohler Power Systems" },
    { "kod": 88, "namn": "Hemisphere GPS Inc" },
    { "kod": 116, "namn": "BEP Marine" },
    { "kod": 135, "namn": "Airmar" },
    { "kod": 137, "namn": "Maretron" },
    { "kod": 140, "namn": "Lowrance" },
    { "kod": 144, "namn": "Mercury Marine" },
    { "kod": 147, "namn": "Nautibus Electronic GmbH" },
    { "kod": 148, "namn": "Blue Water Data" },
    { "kod": 154, "namn": "Westerbeke" },
    { "kod": 157, "namn": "ISSPRO Inc" },
    { "kod": 161, "namn": "Offshore Systems (UK) Ltd." },
    { "kod": 163, "namn": "Evinrude/BRP" },
    { "kod": 165, "namn": "CPAC Systems AB" },
    { "kod": 168, "namn": "Xantrex Technology Inc." },
    { "kod": 169, "namn": "Marlin Technologies, Inc." },
    { "kod": 172, "namn": "Yanmar Marine" },
    { "kod": 174, "namn": "Volvo Penta" },
    { "kod": 175, "namn": "Honda Marine" },
    { "kod": 176, "namn": "Carling Technologies Inc. (Moritz Aerospace)" },
    { "kod": 185, "namn": "Beede Instruments" },
    { "kod": 192, "namn": "Floscan Instrument Co. Inc." },
    { "kod": 193, "namn": "Nobletec" },
    { "kod": 198, "namn": "Mystic Valley Communications" },
    { "kod": 199, "namn": "Actia" },
    { "kod": 200, "namn": "Honda Marine 2" },
    { "kod": 201, "namn": "Disenos Y Technologia" },
    { "kod": 211, "namn": "Digital Switching Systems" },
    { "kod": 215, "namn": "Xintex/Atena" },
    { "kod": 224, "namn": "EMMI NETWORK S.L." },
    { "kod": 225, "namn": "Honda Marine 3" },
    { "kod": 228, "namn": "ZF" },
    { "kod": 229, "namn": "Garmin" },
    { "kod": 233, "namn": "Yacht Monitoring Solutions" },
    { "kod": 235, "namn": "Sailormade Marine Telemetry/Tetra Technology LTD" },
    { "kod": 243, "namn": "Eride" },
    { "kod": 250, "namn": "Honda Marine 4" },
    { "kod": 257, "namn": "Honda Motor Company LTD" },
    { "kod": 272, "namn": "Groco" },
    { "kod": 273, "namn": "Actisense" },
    { "kod": 274, "namn": "Amphenol LTW Technology" },
    { "kod": 275, "namn": "Navico" },
    { "kod": 283, "namn": "Hamilton Jet" },
    { "kod": 285, "namn": "Sea Recovery" },
    { "kod": 286, "namn": "Coelmo SRL Italy" },
    { "kod": 295, "namn": "BEP Marine 2" },
    { "kod": 304, "namn": "Empir Bus" },
    { "kod": 305, "namn": "NovAtel" },
    { "kod": 306, "namn": "Sleipner Motor AS" },
    { "kod": 307, "namn": "MBW Technologies" },
    { "kod": 311, "namn": "Fischer Panda" },
    { "kod": 315, "namn": "ICOM" },
    { "kod": 328, "namn": "Qwerty" },
    { "kod": 329, "namn": "Dief" },
    { "kod": 341, "namn": "Boening Automationstechnologie GmbH & Co. KG" },
    { "kod": 345, "namn": "Korean Maritime University" },
    { "kod": 351, "namn": "Thrane and Thrane" },
    { "kod": 355, "namn": "Mastervolt" },
    { "kod": 356, "namn": "Fischer Panda Generators" },
    { "kod": 358, "namn": "Victron Energy" },
    { "kod": 370, "namn": "Rolls Royce Marine" },
    { "kod": 373, "namn": "Electronic Design" },
    { "kod": 374, "namn": "Northern Lights" },
    { "kod": 378, "namn": "Glendinning" },
    { "kod": 381, "namn": "B & G" },
    { "kod": 384, "namn": "Rose Point Navigation Systems" },
    { "kod": 385, "namn": "Johnson Outdoors Marine Electronics Inc Geonav" },
    { "kod": 394, "namn": "Capi 2" },
    { "kod": 396, "namn": "Beyond Measure" },
    { "kod": 400, "namn": "Livorsi Marine" },
    { "kod": 404, "namn": "ComNav" },
    { "kod": 409, "namn": "Chetco" },
    { "kod": 419, "namn": "Fusion Electronics" },
    { "kod": 421, "namn": "Standard Horizon" },
    { "kod": 422, "namn": "True Heading AB" },
    { "kod": 426, "namn": "Egersund Marine Electronics AS" },
    { "kod": 427, "namn": "em-trak Marine Electronics" },
    { "kod": 431, "namn": "Tohatsu Co, JP" },
    { "kod": 437, "namn": "Digital Yacht" },
    { "kod": 438, "namn": "Comar Systems Limited" },
    { "kod": 440, "namn": "Cummins" },
    { "kod": 443, "namn": "VDO (aka Continental-Corporation)" },
    { "kod": 451, "namn": "Parker Hannifin aka Village Marine Tech" },
    { "kod": 459, "namn": "Alltek Marine Electronics Corp" },
    { "kod": 460, "namn": "SAN GIORGIO S.E.I.N" },
    { "kod": 466, "namn": "Veethree Electronics & Marine" },
    { "kod": 467, "namn": "Humminbird Marine Electronics" },
    { "kod": 470, "namn": "SI-TEX Marine Electronics" },
    { "kod": 471, "namn": "Sea Cross Marine AB" },
    { "kod": 475, "namn": "GME aka Standard Communications Pty LTD" },
    { "kod": 476, "namn": "Humminbird Marine Electronics 2" },
    { "kod": 478, "namn": "Ocean Sat BV" },
    { "kod": 481, "namn": "Chetco Digitial Instruments" },
    { "kod": 493, "namn": "Watcheye" },
    { "kod": 499, "namn": "Lcj Capteurs" },
    { "kod": 502, "namn": "Attwood Marine" },
    { "kod": 503, "namn": "Naviop S.R.L." },
    { "kod": 504, "namn": "Vesper Marine Ltd" },
    { "kod": 510, "namn": "Marinesoft Co. LTD" },
    { "kod": 513, "namn": "Simarine" },
    { "kod": 517, "namn": "NoLand Engineering" },
    { "kod": 518, "namn": "Transas USA" },
    { "kod": 529, "namn": "National Instruments Korea" },
    { "kod": 530, "namn": "National Marine Electronics Association" },
    { "kod": 532, "namn": "Onwa Marine" },
    { "kod": 540, "namn": "Webasto" },
    { "kod": 571, "namn": "Marinecraft (South Korea)" },
    { "kod": 573, "namn": "McMurdo Group aka Orolia LTD" },
    { "kod": 578, "namn": "Advansea" },
    { "kod": 579, "namn": "KVH" },
    { "kod": 580, "namn": "San Jose Technology" },
    { "kod": 583, "namn": "Yacht Control" },
    { "kod": 586, "namn": "Suzuki Motor Corporation" },
    { "kod": 591, "namn": "US Coast Guard" },
    { "kod": 595, "namn": "Ship Module aka Customware" },
    { "kod": 600, "namn": "Aquatic AV" },
    { "kod": 605, "namn": "Aventics GmbH" },
    { "kod": 606, "namn": "Intellian" },
    { "kod": 612, "namn": "SamwonIT" },
    { "kod": 614, "namn": "Arlt Tecnologies" },
    { "kod": 637, "namn": "Bavaria Yacts" },
    { "kod": 641, "namn": "Diverse Yacht Services" },
    { "kod": 644, "namn": "Wema U.S.A dba KUS" },
    { "kod": 645, "namn": "Garmin 2" },
    { "kod": 658, "namn": "Shenzhen Jiuzhou Himunication" },
    { "kod": 688, "namn": "Rockford Corp" },
    { "kod": 699, "namn": "Harman International" },
    { "kod": 704, "namn": "JL Audio" },
    { "kod": 708, "namn": "Lars Thrane" },
    { "kod": 715, "namn": "Autonnic" },
    { "kod": 717, "namn": "Yacht Devices" },
    { "kod": 734, "namn": "REAP Systems" },
    { "kod": 735, "namn": "Au Electronics Group" },
    { "kod": 739, "namn": "LxNav" },
    { "kod": 741, "namn": "Littelfuse, Inc (formerly Carling Technologies)" },
    { "kod": 743, "namn": "DaeMyung" },
    { "kod": 744, "namn": "Woosung" },
    { "kod": 748, "namn": "ISOTTA IFRA srl" },
    { "kod": 773, "namn": "Clarion US" },
    { "kod": 776, "namn": "HMI Systems" },
    { "kod": 777, "namn": "Ocean Signal" },
    { "kod": 778, "namn": "Seekeeper" },
    { "kod": 781, "namn": "Poly Planar" },
    { "kod": 785, "namn": "Fischer Panda DE" },
    { "kod": 795, "namn": "Broyda Industries" },
    { "kod": 796, "namn": "Canadian Automotive" },
    { "kod": 797, "namn": "Tides Marine" },
    { "kod": 798, "namn": "Lumishore" },
    { "kod": 799, "namn": "Still Water Designs and Audio" },
    { "kod": 802, "namn": "BJ Technologies (Beneteau)" },
    { "kod": 803, "namn": "Gill Sensors" },
    { "kod": 811, "namn": "Blue Water Desalination" },
    { "kod": 815, "namn": "FLIR" },
    { "kod": 824, "namn": "Undheim Systems" },
    { "kod": 826, "namn": "Lewmar Inc" },
    { "kod": 838, "namn": "TeamSurv" },
    { "kod": 844, "namn": "Fell Marine" },
    { "kod": 847, "namn": "Oceanvolt" },
    { "kod": 862, "namn": "Prospec" },
    { "kod": 868, "namn": "Data Panel Corp" },
    { "kod": 890, "namn": "L3 Technologies" },
    { "kod": 894, "namn": "Rhodan Marine Systems" },
    { "kod": 896, "namn": "Nexfour Solutions" },
    { "kod": 905, "namn": "ASA Electronics" },
    { "kod": 909, "namn": "Marines Co (South Korea)" },
    { "kod": 911, "namn": "Nautic-on" },
    { "kod": 917, "namn": "Sentinel" },
    { "kod": 929, "namn": "JL Marine ystems" },
    { "kod": 930, "namn": "Ecotronix" },
    { "kod": 944, "namn": "Zontisa Marine" },
    { "kod": 951, "namn": "EXOR International" },
    { "kod": 962, "namn": "Timbolier Industries" },
    { "kod": 963, "namn": "TJC Micro" },
    { "kod": 968, "namn": "Cox Powertrain" },
    { "kod": 969, "namn": "Blue Seas" },
    { "kod": 981, "namn": "Kobelt Manufacturing Co. Ltd" },
    { "kod": 992, "namn": "Blue Ocean IOT" },
    { "kod": 997, "namn": "Xenta Systems" },
    { "kod": 999, "namn": "Signal K" },
    { "kod": 1004, "namn": "Ultraflex SpA" },
    { "kod": 1008, "namn": "Lintest SmartBoat" },
    { "kod": 1011, "namn": "Soundmax" },
    { "kod": 1020, "namn": "Team Italia Marine (Onyx Marine Automation s.r.l)" },
    { "kod": 1021, "namn": "Entratech" },
    { "kod": 1022, "namn": "ITC Inc." },
    { "kod": 1029, "namn": "The Marine Guardian LLC" },
    { "kod": 1047, "namn": "Sonic Corporation" },
    { "kod": 1051, "namn": "ProNav" },
    { "kod": 1053, "namn": "Vetus Maxwell INC." },
    { "kod": 1056, "namn": "Lithium Pros" },
    { "kod": 1059, "namn": "Boatrax" },
    { "kod": 1062, "namn": "Marol Co ltd" },
    { "kod": 1065, "namn": "CALYPSO Instruments" },
    { "kod": 1066, "namn": "Spot Zero Water" },
    { "kod": 1069, "namn": "Lithionics Battery LLC" },
    { "kod": 1070, "namn": "Quick-teck Electronics Ltd" },
    { "kod": 1075, "namn": "Uniden America" },
    { "kod": 1083, "namn": "Nauticoncept" },
    { "kod": 1084, "namn": "Shadow-Caster LED lighting LLC" },
    { "kod": 1085, "namn": "Wet Sounds, LLC" },
    { "kod": 1088, "namn": "E-T-A Circuit Breakers" },
    { "kod": 1092, "namn": "Scheiber" },
    { "kod": 1100, "namn": "Smart Yachts International Limited" },
    { "kod": 1109, "namn": "Dockmate" },
    { "kod": 1114, "namn": "Bobs Machine" },
    { "kod": 1118, "namn": "L3Harris ASV" },
    { "kod": 1119, "namn": "Balmar LLC" },
    { "kod": 1120, "namn": "Elettromedia spa" },
    { "kod": 1127, "namn": "Electromaax" },
    { "kod": 1140, "namn": "Across Oceans Systems Ltd." },
    { "kod": 1145, "namn": "Kiwi Yachting" },
    { "kod": 1150, "namn": "BSB Artificial Intelligence GmbH" },
    { "kod": 1151, "namn": "Orca Technologoes AS" },
    { "kod": 1154, "namn": "TBS Electronics BV" },
    { "kod": 1158, "namn": "Technoton Electroics" },
    { "kod": 1160, "namn": "MG Energy Systems B.V." },
    { "kod": 1169, "namn": "Sea Macine Robotics Inc." },
    { "kod": 1171, "namn": "Vista Manufacturing" },
    { "kod": 1183, "namn": "Zipwake" },
    { "kod": 1186, "namn": "Sailmon BV" },
    { "kod": 1192, "namn": "Airmoniq Pro Kft" },
    { "kod": 1194, "namn": "Sierra Marine" },
    { "kod": 1200, "namn": "Xinuo Information Technology (Xiamen)" },
    { "kod": 1218, "namn": "Septentrio" },
    { "kod": 1233, "namn": "NKE Marine Elecronics" },
    { "kod": 1238, "namn": "SuperTrack Aps" },
    { "kod": 1239, "namn": "Honda Electronics Co., LTD" },
    { "kod": 1245, "namn": "Raritan Engineering Company, Inc" },
    { "kod": 1249, "namn": "Integrated Power Solutions AG" },
    { "kod": 1260, "namn": "Interactive Technologies, Inc." },
    { "kod": 1283, "namn": "LTG-Tech" },
    { "kod": 1299, "namn": "Energy Solutions (UK) LTD." },
    { "kod": 1300, "namn": "WATT Fuel Cell Corp" },
    { "kod": 1302, "namn": "Pro Mainer" },
    { "kod": 1305, "namn": "Dragonfly Energy" },
    { "kod": 1306, "namn": "Koden Electronics Co., Ltd" },
    { "kod": 1311, "namn": "Humphree AB" },
    { "kod": 1316, "namn": "Hinkley Yachts" },
    { "kod": 1317, "namn": "Global Marine Management GmbH (GMM)" },
    { "kod": 1320, "namn": "Triskel Marine Ltd" },
    { "kod": 1330, "namn": "Warwick Control Technologies" },
    { "kod": 1331, "namn": "Dolphin Charger" },
    { "kod": 1337, "namn": "Barnacle Systems Inc" },
    { "kod": 1348, "namn": "Radian IoT, Inc." },
    { "kod": 1353, "namn": "Ocean LED Marine Ltd" },
    { "kod": 1359, "namn": "BluNav" },
    { "kod": 1361, "namn": "OVA (Nantong Saiyang Electronics Co., Ltd)" },
    { "kod": 1368, "namn": "RAD Propulsion" },
    { "kod": 1369, "namn": "Electric Yacht" },
    { "kod": 1372, "namn": "Elco Motor Yachts" },
    { "kod": 1384, "namn": "Tecnoseal Foundry S.r.l" },
    { "kod": 1385, "namn": "Pro Charging Systems, LLC" },
    { "kod": 1389, "namn": "EVEX Co., LTD" },
    { "kod": 1398, "namn": "Gobius Sensor Technology AB" },
    { "kod": 1403, "namn": "Arco Marine" },
    { "kod": 1408, "namn": "Lenco Marine Inc." },
    { "kod": 1413, "namn": "Naocontrol S.L." },
    { "kod": 1417, "namn": "Revatek" },
    { "kod": 1438, "namn": "Aeolionics" },
    { "kod": 1439, "namn": "PredictWind Ltd" },
    { "kod": 1440, "namn": "Egis Mobile Electric" },
    { "kod": 1445, "namn": "Starboard Yacht Group" },
    { "kod": 1446, "namn": "Roswell Marine" },
    { "kod": 1451, "namn": "ePropulsion (Guangdong ePropulsion Technology Ltd.)" },
    { "kod": 1452, "namn": "Micro-Air LLC" },
    { "kod": 1453, "namn": "Vital Battery" },
    { "kod": 1458, "namn": "Ride Controller LLC" },
    { "kod": 1460, "namn": "Tocaro Blue" },
    { "kod": 1461, "namn": "Vanquish Yachts" },
    { "kod": 1471, "namn": "FT Technologies" },
    { "kod": 1478, "namn": "Alps Alpine Co., Ltd." },
    { "kod": 1481, "namn": "E-Force Marine" },
    { "kod": 1482, "namn": "CMC Marine" },
    { "kod": 1483, "namn": "Nanjing Sandemarine Information Technology Co., Ltd." },
    { "kod": 1850, "namn": "Teleflex Marine (SeaStar Solutions)" },
    { "kod": 1851, "namn": "Raymarine" },
    { "kod": 1852, "namn": "Navionics" },
    { "kod": 1853, "namn": "Japan Radio Co" },
    { "kod": 1854, "namn": "Northstar Technologies" },
    { "kod": 1855, "namn": "Furuno" },
    { "kod": 1856, "namn": "Trimble" },
    { "kod": 1857, "namn": "Simrad" },
    { "kod": 1858, "namn": "Litton" },
    { "kod": 1859, "namn": "Kvasar AB" },
    { "kod": 1860, "namn": "MMP" },
    { "kod": 1861, "namn": "Vector Cantech" },
    { "kod": 1862, "namn": "Yamaha Marine" },
    { "kod": 1863, "namn": "Faria Instruments" }
  ],
  "klasser": [
    { "kod": 0, "namn": "Reserved for 2000 Use" },
    { "kod": 10, "namn": "System tools" },
    { "kod": 20, "namn": "Safety systems" },
    { "kod": 25, "namn": "Internetwork device" },
    { "kod": 30, "namn": "Electrical Distribution" },
    { "kod": 35, "namn": "Electrical Generation" },
    { "kod": 40, "namn": "Steering and Control surfaces" },
    { "kod": 50, "namn": "Propulsion" },
    { "kod": 60, "namn": "Navigation" },
    { "kod": 70, "namn": "Communication" },
    { "kod": 75, "namn": "Sensor Communication Interface" },
    { "kod": 80, "namn": "Instrumentation/general systems" },
    { "kod": 85, "namn": "External Environment" },
    { "kod": 90, "namn": "Internal Environment" },
    { "kod": 100, "namn": "Deck + cargo + fishing equipment systems" },
    { "kod": 110, "namn": "Human Interface" },
    { "kod": 120, "namn": "Display" },
    { "kod": 125, "namn": "Entertainment" }
  ],
  "funktioner": [
    { "klass": 10, "funktion": 130, "namn": "Diagnostic" },
    { "klass": 10, "funktion": 140, "namn": "Bus Traffic Logger" },
    { "klass": 20, "funktion": 110, "namn": "Alarm Enunciator" },
    { "klass": 20, "funktion": 130, "namn": "Emergency Position Indicating Radio Beacon (EPIRB)" },
    { "klass": 20, "funktion": 135, "namn": "Man Overboard" },
    { "klass": 20, "funktion": 140, "namn": "Voyage Data Recorder" },
    { "klass": 20, "funktion": 150, "namn": "Camera" },
    { "klass": 25, "funktion": 130, "namn": "PC Gateway" },
    { "klass": 25, "funktion": 131, "namn": "NMEA 2000 to Analog Gateway" },
    { "klass": 25, "funktion": 132, "namn": "Analog to NMEA 2000 Gateway" },
    { "klass": 25, "funktion": 133, "namn": "NMEA 2000 to Serial Gateway" },
    { "klass": 25, "funktion": 135, "namn": "NMEA 0183 Gateway" },
    { "klass": 25, "funktion": 136, "namn": "NMEA Network Gateway" },
    { "klass": 25, "funktion": 137, "namn": "NMEA 2000 Wireless Gateway" },
    { "klass": 25, "funktion": 140, "namn": "Router" },
    { "klass": 25, "funktion": 150, "namn": "Bridge" },
    { "klass": 25, "funktion": 160, "namn": "Repeater" },
    { "klass": 30, "funktion": 130, "namn": "Binary Event Monitor" },
    { "klass": 30, "funktion": 140, "namn": "Load Controller" },
    { "klass": 30, "funktion": 141, "namn": "AC/DC Input" },
    { "klass": 30, "funktion": 150, "namn": "Function Controller" },
    { "klass": 35, "funktion": 140, "namn": "Engine" },
    { "klass": 35, "funktion": 141, "namn": "DC Generator/Alternator" },
    { "klass": 35, "funktion": 142, "namn": "Solar Panel (Solar Array)" },
    { "klass": 35, "funktion": 143, "namn": "Wind Generator (DC)" },
    { "klass": 35, "funktion": 144, "namn": "Fuel Cell" },
    { "klass": 35, "funktion": 145, "namn": "Network Power Supply" },
    { "klass": 35, "funktion": 151, "namn": "AC Generator" },
    { "klass": 35, "funktion": 152, "namn": "AC Bus" },
    { "klass": 35, "funktion": 153, "namn": "AC Mains (Utility/Shore)" },
    { "klass": 35, "funktion": 154, "namn": "AC Output" },
    { "klass": 35, "funktion": 160, "namn": "Power Converter - Battery Charger" },
    { "klass": 35, "funktion": 161, "namn": "Power Converter - Battery Charger+Inverter" },
    { "klass": 35, "funktion": 162, "namn": "Power Converter - Inverter" },
    { "klass": 35, "funktion": 163, "namn": "Power Converter - DC" },
    { "klass": 35, "funktion": 170, "namn": "Battery" },
    { "klass": 35, "funktion": 180, "namn": "Engine Gateway" },
    { "klass": 40, "funktion": 130, "namn": "Follow-up Controller" },
    { "klass": 40, "funktion": 140, "namn": "Mode Controller" },
    { "klass": 40, "funktion": 150, "namn": "Autopilot" },
    { "klass": 40, "funktion": 155, "namn": "Rudder" },
    { "klass": 40, "funktion": 160, "namn": "Heading Sensors" },
    { "klass": 40, "funktion": 170, "namn": "Trim (Tabs)/Interceptors" },
    { "klass": 40, "funktion": 180, "namn": "Attitude (Pitch, Roll, Yaw) Control" },
    { "klass": 50, "funktion": 130, "namn": "Engineroom Monitoring" },
    { "klass": 50, "funktion": 140, "namn": "Engine" },
    { "klass": 50, "funktion": 141, "namn": "DC Generator/Alternator" },
    { "klass": 50, "funktion": 150, "namn": "Engine Controller" },
    { "klass": 50, "funktion": 151, "namn": "AC Generator" },
    { "klass": 50, "funktion": 155, "namn": "Motor" },
    { "klass": 50, "funktion": 160, "namn": "Engine Gateway" },
    { "klass": 50, "funktion": 165, "namn": "Transmission" },
    { "klass": 50, "funktion": 170, "namn": "Throttle/Shift Control" },
    { "klass": 50, "funktion": 180, "namn": "Actuator" },
    { "klass": 50, "funktion": 190, "namn": "Gauge Interface" },
    { "klass": 50, "funktion": 200, "namn": "Gauge Large" },
    { "klass": 50, "funktion": 210, "namn": "Gauge Small" },
    { "klass": 60, "funktion": 130, "namn": "Bottom Depth" },
    { "klass": 60, "funktion": 135, "namn": "Bottom Depth/Speed" },
    { "klass": 60, "funktion": 136, "namn": "Bottom Depth/Speed/Temperature" },
    { "klass": 60, "funktion": 140, "namn": "Ownship Attitude" },
    { "klass": 60, "funktion": 145, "namn": "Ownship Position (GNSS)" },
    { "klass": 60, "funktion": 150, "namn": "Ownship Position (Loran C)" },
    { "klass": 60, "funktion": 155, "namn": "Speed" },
    { "klass": 60, "funktion": 160, "namn": "Turn Rate Indicator" },
    { "klass": 60, "funktion": 170, "namn": "Integrated Navigation" },
    { "klass": 60, "funktion": 175, "namn": "Integrated Navigation System" },
    { "klass": 60, "funktion": 190, "namn": "Navigation Management" },
    { "klass": 60, "funktion": 195, "namn": "Automatic Identification System (AIS)" },
    { "klass": 60, "funktion": 200, "namn": "Radar" },
    { "klass": 60, "funktion": 201, "namn": "Infrared Imaging" },
    { "klass": 60, "funktion": 205, "namn": "ECDIS" },
    { "klass": 60, "funktion": 210, "namn": "ECS" },
    { "klass": 60, "funktion": 220, "namn": "Direction Finder" },
    { "klass": 60, "funktion": 230, "namn": "Voyage Status" },
    { "klass": 70, "funktion": 130, "namn": "EPIRB" },
    { "klass": 70, "funktion": 140, "namn": "AIS" },
    { "klass": 70, "funktion": 150, "namn": "DSC" },
    { "klass": 70, "funktion": 160, "namn": "Data Receiver/Transceiver" },
    { "klass": 70, "funktion": 170, "namn": "Satellite" },
    { "klass": 70, "funktion": 180, "namn": "Radio-telephone (MF/HF)" },
    { "klass": 70, "funktion": 190, "namn": "Radiotelephone" },
    { "klass": 75, "funktion": 130, "namn": "Temperature" },
    { "klass": 75, "funktion": 140, "namn": "Pressure" },
    { "klass": 75, "funktion": 150, "namn": "Fluid Level" },
    { "klass": 75, "funktion": 160, "namn": "Flow" },
    { "klass": 75, "funktion": 170, "namn": "Humidity" },
    { "klass": 80, "funktion": 130, "namn": "Time/Date Systems" },
    { "klass": 80, "funktion": 140, "namn": "VDR" },
    { "klass": 80, "funktion": 150, "namn": "Integrated Instrumentation" },
    { "klass": 80, "funktion": 160, "namn": "General Purpose Displays" },
    { "klass": 80, "funktion": 170, "namn": "General Sensor Box" },
    { "klass": 80, "funktion": 180, "namn": "Weather Instruments" },
    { "klass": 80, "funktion": 190, "namn": "Transducer/General" },
    { "klass": 80, "funktion": 200, "namn": "NMEA 0183 Converter" },
    { "klass": 85, "funktion": 130, "namn": "Atmospheric" },
    { "klass": 85, "funktion": 160, "namn": "Aquatic" },
    { "klass": 90, "funktion": 130, "namn": "HVAC" },
    { "klass": 100, "funktion": 130, "namn": "Scale (Catch)" },
    { "klass": 110, "funktion": 130, "namn": "Button Interface" },
    { "klass": 110, "funktion": 135, "namn": "Switch Interface" },
    { "klass": 110, "funktion": 140, "namn": "Analog Interface" },
    { "klass": 120, "funktion": 130, "namn": "Display" },
    { "klass": 120, "funktion": 140, "namn": "Alarm Enunciator" },
    { "klass": 125, "funktion": 130, "namn": "Multimedia Player" },
    { "klass": 125, "funktion": 140, "namn": "Multimedia Controller" }
  ]
}
